import {css, html, LitElement, nothing} from 'lit';
import {consume} from '@lit/context';
import {customElement, state} from 'lit/decorators.js'
import {classMap} from 'lit/directives/class-map.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import {IReportNews, services} from 'src/services';
import {editModeContext} from 'src/context/content-context';
import {subscriberKeyContext} from 'src/context/subscriber-context';

@customElement('report-news')
export class ReportNews extends LitElement {
  static styles = [
    css`
      .news {
        position: relative;
        margin-bottom: 16px;
      }

      .overlap-top-right {
        position: absolute;
        top: 0;
        right: 0;
      }

      .preview {
        &[source] {
          position: relative;
        }

        &[source]:hover {
          outline: black 1px solid;
        }

        &[source]:hover::before {
          content: attr(source);
          width: max-content;
          background-color: black;
          outline: black 1px solid;
          color: #fff;
          text-align: center;
          bottom: 0;
          right: 0;
          padding: 1em;
          position: absolute;
        }
      }
    `
  ];

  private static editModeCache = new Map<number, IReportNews[]>();

  @consume({context: editModeContext}) public editMode: boolean = false;
  @consume({context: subscriberKeyContext}) public subscriberKey?: number;

  @state() reportNews: IReportNews[] = [];

  connectedCallback() {
    super.connectedCallback();

    if (this.editMode && this.subscriberKey != null) {
      const cachedReportNews = ReportNews.editModeCache.get(this.subscriberKey);
      if (cachedReportNews) {
        this.reportNews = cachedReportNews;
        return;
      }
    }

    services.report.news(this.editMode, this.subscriberKey).then((reportNews: IReportNews[]) => {
      this.reportNews = reportNews;
      if (this.editMode && this.subscriberKey != null) {
        ReportNews.editModeCache.set(this.subscriberKey, reportNews);
      }
    });
  }

  dismissNews = async (reportKey: number) => {
    this.reportNews = this.reportNews.filter(news => news.reportKey !== reportKey);
    await services.report.dismissNews(reportKey);
  }

  render() {
    const classes = {news: true, preview: this.editMode};
    return this.reportNews.length > 0
      ? html`
        <div>
          <slot></slot>
          ${this.reportNews.map((news) =>
            html`
              <div class=${classMap(classes)} source="${news.name}">
                ${unsafeHTML(news.html)}
                ${!this.editMode ? html`
                  <close-button class="overlap-top-right" title="Dismiss" @close-view=${async (e: Event) => {
                    e.stopPropagation();
                    await this.dismissNews(news.reportKey);
                  }}></close-button>` : nothing}
              </div>`
          )}
        </div>`
      : html``;
  }
}
